import { useEffect } from "react";
import styles from "./Drawer.module.scss";

// Ref-counted so a drawer stacked on top of another one (e.g. editing an
// invoice's template without leaving the invoice) does not release the page
// behind when only the top drawer closes.
let openDrawerCount = 0;

export function usePreventBodyScroll(isOpen?: boolean) {
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        openDrawerCount += 1;
        document.body.classList.add(styles.noScroll);

        return () => {
            openDrawerCount -= 1;
            if (openDrawerCount === 0) {
                document.body.classList.remove(styles.noScroll);
            }
        };
    }, [isOpen]);
}
